'use strict';

exports.__esModule = true;
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _utilElement = require('utils/util-element');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurveyHeader = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    survey: state.survey.data.data,
    selectedLanguage: state.survey.selectedLanguage
  };
}, null), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SurveyHeader, _Component);

  function SurveyHeader(props) {
    (0, _classCallCheck3.default)(this, SurveyHeader);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = require('./SurveyHeader.scss');
    _this.buttonStyle = { borderRadius: '25px' };
    _this.state = {
      current_move: 'forward',
      sequence_no: 1,
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) <= 768 ? 'mobile' : 'desktop',
      theme: _this.props.theme
    };
    return _this;
  }

  SurveyHeader.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.theme.colorCode !== this.props.theme.colorCode && (0, _keys2.default)(this.props.theme.length > 0)) {
      this.updateTheme(this.props.theme);
    }
  };

  SurveyHeader.prototype.updateTheme = function updateTheme(theme) {
    this.setState({ theme: theme });
  };

  SurveyHeader.prototype.render = function render() {
    var survey = this.props.survey;

    var style = { color: this.state.theme && this.state.theme.customTextColor ? this.state.theme.customTextColor : '#fff' };
    return _react2.default.createElement(
      'div',
      { className: this.styles.survey_header_container },
      _react2.default.createElement(
        _Row2.default,
        { className: this.styles.survey_question_header, style: { zIndex: '10' } },
        _react2.default.createElement(_components.SurveyLogo, { theme: this.state.theme.colorCode }),
        _react2.default.createElement(
          _Col2.default,
          { md: 3, sm: 3, xs: 4 },
          _react2.default.createElement(
            'div',
            { className: this.styles.logo_container },
            _react2.default.createElement('img', { src: this.props.clientLogoUrl })
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { md: 7, sm: 7, xs: 8 },
          survey && _react2.default.createElement(
            'div',
            { className: this.styles.survey_name, style: style },
            (0, _utilElement.getTextForLanguage)(survey.name, this.props.selectedLanguage)
          )
        ),
        _react2.default.createElement(
          _Col2.default,
          { md: 2, sm: 2, xsHidden: true },
          this.props.showBranding && _react2.default.createElement(
            'div',
            { className: this.styles.signature_container },
            _react2.default.createElement(
              'div',
              { className: this.styles.powered_by, style: style },
              'POWERED BY',
              _react2.default.createElement('br', null)
            ),
            _react2.default.createElement(
              'div',
              { className: this.styles.powered_by_name },
              _react2.default.createElement('img', { src: 'https://cdn.consumerism.pressganey.com/pgforsta.png', title: 'Powered by Press Ganey Consumer Experience' })
            )
          )
        )
      )
    );
  };

  return SurveyHeader;
}(_react.Component), _class2.propTypes = {
  survey: _react.PropTypes.object,
  params: _react.PropTypes.object,
  theme: _react.PropTypes.object,
  getTextForLanguage: _react.PropTypes.func,
  clientLogoUrl: _react.PropTypes.string,
  selectedLanguage: _react.PropTypes.string,
  showBranding: _react.PropTypes.boolean
}, _temp)) || _class);
exports.default = SurveyHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SurveyHeader/SurveyHeader.js
// module id = 2326
// module chunks = 0